import "core-js/modules/es.array.concat.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_c('b-card', {
    staticClass: "mb-12 border border-primary",
    attrs: {
      "title": "Configuração White Label",
      "tag": "article"
    }
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Cor Primária",
      "label-for": "cor_primaria"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "color"
    },
    model: {
      value: _vm.form.cor_primaria,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "cor_primaria", $$v);
      },
      expression: "form.cor_primaria"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Cor Primária Hover",
      "label-for": "cor_primaria"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "color"
    },
    model: {
      value: _vm.form.cor_primaria_hover,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "cor_primaria_hover", $$v);
      },
      expression: "form.cor_primaria_hover"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Cor Secundária",
      "label-for": "cor_secundaria"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "color"
    },
    model: {
      value: _vm.form.cor_secundaria,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "cor_secundaria", $$v);
      },
      expression: "form.cor_secundaria"
    }
  })], 1)], 1)], 1), _c('div', {
    staticClass: "brand-assets mt-4"
  }, [_c('div', {
    staticClass: "mb-3"
  }, [_c('h4', {
    staticClass: "mb-1"
  }, [_vm._v("Imagens da plataforma")]), _c('p', {
    staticClass: "text-muted mb-0"
  }, [_vm._v(" Selecione uma imagem e ajuste o tamanho para visualizar como ela ficará na aplicação. ")])]), _c('b-row', _vm._l(_vm.brandAssets, function (asset) {
    return _c('b-col', {
      key: asset.field,
      staticClass: "mb-4",
      attrs: {
        "cols": "12",
        "lg": "6"
      }
    }, [_c('div', {
      staticClass: "brand-asset-card"
    }, [_c('div', {
      staticClass: "brand-asset-card__header"
    }, [_c('div', [_c('strong', [_vm._v(_vm._s(asset.label))]), _c('small', {
      staticClass: "d-block text-muted"
    }, [_vm._v(" " + _vm._s(asset.location) + " ")])]), asset.sizeField ? _c('span', {
      staticClass: "brand-asset-card__size"
    }, [_vm._v(" " + _vm._s(_vm.getBrandAssetSize(asset)) + " px ")]) : _vm._e()]), _c('b-form-file', {
      attrs: {
        "accept": ".jpg, .jpeg, .png",
        "placeholder": "Selecione ".concat(asset.article, " ").concat(asset.label.toLowerCase(), "..."),
        "drop-placeholder": "Solte a imagem aqui..."
      },
      on: {
        "change": function change($event) {
          return _vm.setBrandAsset($event, asset);
        }
      }
    }), asset.sizeField ? _c('div', {
      staticClass: "brand-size-control"
    }, [_c('label', {
      attrs: {
        "for": "range-".concat(asset.sizeField)
      }
    }, [_vm._v(" Tamanho da imagem ")]), _c('div', {
      staticClass: "brand-size-control__inputs"
    }, [_c('b-form-input', {
      attrs: {
        "id": "range-".concat(asset.sizeField),
        "type": "range",
        "min": asset.min,
        "max": asset.max,
        "step": "1"
      },
      model: {
        value: _vm.form[asset.sizeField],
        callback: function callback($$v) {
          _vm.$set(_vm.form, asset.sizeField, _vm._n($$v));
        },
        expression: "form[asset.sizeField]"
      }
    }), _c('b-input-group', {
      staticClass: "brand-size-control__number",
      attrs: {
        "append": "px"
      }
    }, [_c('b-form-input', {
      attrs: {
        "type": "number",
        "min": asset.min,
        "max": asset.max
      },
      on: {
        "blur": function blur($event) {
          return _vm.normalizeBrandAssetSize(asset);
        }
      },
      model: {
        value: _vm.form[asset.sizeField],
        callback: function callback($$v) {
          _vm.$set(_vm.form, asset.sizeField, _vm._n($$v));
        },
        expression: "form[asset.sizeField]"
      }
    })], 1)], 1)]) : _vm._e(), _c('div', {
      staticClass: "brand-preview",
      class: "brand-preview--".concat(asset.preview)
    }, [!asset.url ? _c('div', {
      staticClass: "brand-preview__empty"
    }, [_c('i', {
      staticClass: "far fa-image"
    }), _c('span', [_vm._v("Selecione uma imagem para visualizar")])]) : _vm._e(), asset.url ? [asset.preview === 'login' ? _c('div', {
      staticClass: "brand-preview__login"
    }, [_c('img', {
      style: _vm.brandAssetStyle(asset),
      attrs: {
        "src": asset.url,
        "alt": "Pr\xE9-visualiza\xE7\xE3o da ".concat(asset.label.toLowerCase())
      }
    }), _c('div', {
      staticClass: "brand-preview__login-title"
    }, [_vm._v(" Acessar o sistema ")]), _c('div', {
      staticClass: "brand-preview__login-field"
    }), _c('div', {
      staticClass: "brand-preview__login-field"
    }), _c('div', {
      staticClass: "brand-preview__login-button"
    }, [_vm._v("Entrar")])]) : asset.preview === 'footer' ? _c('div', {
      staticClass: "brand-preview__digital-link"
    }, [_c('div', {
      staticClass: "brand-preview__digital-content"
    }, [_c('div', {
      staticClass: "brand-preview__document-icon"
    }, [_c('i', {
      staticClass: "far fa-file-alt"
    })]), _c('span'), _c('span'), _c('span')]), _c('div', {
      staticClass: "brand-preview__digital-footer"
    }, [_c('small', [_vm._v("Rodapé do link digital")]), _c('img', {
      style: _vm.brandAssetStyle(asset),
      attrs: {
        "src": asset.url,
        "alt": "Pr\xE9-visualiza\xE7\xE3o da ".concat(asset.label.toLowerCase())
      }
    })])]) : asset.preview === 'header' ? _c('div', {
      staticClass: "brand-preview__header",
      style: {
        backgroundColor: _vm.form.cor_primaria || '#ee7361'
      }
    }, [_c('img', {
      style: _vm.brandAssetStyle(asset),
      attrs: {
        "src": asset.url,
        "alt": "Pr\xE9-visualiza\xE7\xE3o da ".concat(asset.label.toLowerCase())
      }
    }), _c('div', {
      staticClass: "brand-preview__header-navigation"
    }, [_c('span'), _c('span'), _c('span')]), _c('div', {
      staticClass: "brand-preview__avatar"
    })]) : asset.preview === 'compact' ? _c('div', {
      staticClass: "brand-preview__compact-menu"
    }, [_c('div', {
      staticClass: "brand-preview__compact-brand"
    }, [_c('img', {
      style: _vm.brandAssetStyle(asset),
      attrs: {
        "src": asset.url,
        "alt": "Pr\xE9-visualiza\xE7\xE3o da ".concat(asset.label.toLowerCase())
      }
    })]), _c('span'), _c('span'), _c('span')]) : asset.preview === 'browser' ? _c('div', {
      staticClass: "brand-preview__browser"
    }, [_c('div', {
      staticClass: "brand-preview__browser-controls"
    }, [_c('span'), _c('span'), _c('span')]), _c('div', {
      staticClass: "brand-preview__browser-tab"
    }, [_c('img', {
      style: _vm.brandAssetStyle(asset),
      attrs: {
        "src": asset.url,
        "alt": "Pr\xE9-visualiza\xE7\xE3o da ".concat(asset.label.toLowerCase())
      }
    }), _c('span', [_vm._v(_vm._s(_vm.form.app_name || "Nome da plataforma"))])])]) : _vm._e()] : _vm._e(), _c('span', {
      staticClass: "brand-preview__caption"
    }, [_vm._v(" " + _vm._s(asset.previewLabel) + " ")])], 2)], 1)]);
  }), 1)], 1), _c('br'), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "SubDomínio",
      "label-for": "host"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: _vm.form.host,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "host", $$v);
      },
      expression: "form.host"
    }
  })], 1)], 1)], 1), _c('b-row', [_c('h3', {
    staticClass: "text-muted font-weight-bold d-block"
  }, [_vm._v(" Configuração E-mail: ")])]), _c('br'), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "E-mail Host",
      "label-for": "mail_host"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: _vm.form.mail_host,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "mail_host", $$v);
      },
      expression: "form.mail_host"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "E-mail Porta",
      "label-for": "mail_port"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: _vm.form.mail_port,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "mail_port", $$v);
      },
      expression: "form.mail_port"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Usuário",
      "label-for": "mail_username"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: _vm.form.mail_username,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "mail_username", $$v);
      },
      expression: "form.mail_username"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Senha",
      "label-for": "mail_password"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "password"
    },
    model: {
      value: _vm.form.mail_password,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "mail_password", $$v);
      },
      expression: "form.mail_password"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Encryption",
      "label-for": "mail_encryption"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: _vm.form.mail_encryption,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "mail_encryption", $$v);
      },
      expression: "form.mail_encryption"
    }
  })], 1)], 1)], 1), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Nome da plataforma",
      "label-for": "app_name"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "maxlength": "25"
    },
    model: {
      value: _vm.form.app_name,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "app_name", $$v);
      },
      expression: "form.app_name"
    }
  })], 1)], 1)], 1), _c('br'), _c('br'), _c('b-col', {
    staticClass: "col-lg-12",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary font-weight-bold",
    on: {
      "click": _vm.gravarConfiguracao
    }
  }, [_vm._v(" Configurar ")]), _c('router-link', {
    staticClass: "btn btn-clean font-weight-bold",
    attrs: {
      "to": {
        name: 'clientesLista'
      }
    }
  }, [_vm._v(" Voltar ")])], 1)], 1)])], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };